<div class="container">
  <novo-nav theme="white" [outlet]="colorVert" direction="vertical">
    <novo-tab >
      <span>
          <i class="bhi-back-office"></i><span  class="text">Custom Forms</span></span>
  </novo-tab>
    <novo-tab>
      <span>
          <i class="bhi-slideout"></i> <span class="text">Custom Tabs & Cards</span>
        </span>
  </novo-tab>
    <novo-tab>
        <span>
            <i class="bhi-resume"></i><span  class="text">Bulk Resume Parsing</span></span>
    </novo-tab>

  </novo-nav>
  
  <novo-nav-outlet #colorVert>
    <novo-nav-content>
      <h1>Custom Forms</h1>
      <section cdkscrollable class="compose-message-form-body-container scrollable-content ng-star-inserted more-form">
        <main>
          <novo-form *ngIf="textForm" [form]="textForm">
            <div class="novo-form-row">
              <novo-control [form]="textForm" [control]="textControl"></novo-control>
            </div>
            <div class="novo-form-row">
              <novo-control [form]="textForm" [control]="jobOrderPickerControl"></novo-control>
            </div>
            <div class="novo-form-row">
              <novo-control [form]="textForm" [control]="candidatePickerControl"></novo-control>
            </div>
            <div class="novo-form-row">
              <novo-control [form]="textForm" [control]="ownerPickerControl"></novo-control>
            </div>

          </novo-form>
        </main>
      </section>

  </novo-nav-content>
    <novo-nav-content>
      <h1>Custom Tabs & Cards</h1>
      <img src="assets/notecard.png">


    </novo-nav-content>
    <novo-nav-content>
      <h1>Have a lot of unstructured resumes? </h1>
        
      <div class="resume-icons">
        <i class="bhi-file"></i> <span>></span> <i class="bhi-candidate"></i>
      </div>
      <p>
          We can help you parse them into structured data into structured bullhorn data.
      </p>
    </novo-nav-content>

    <novo-nav-content>
        <h1>Custom Reports</h1>
  
        <p>
            Slack and Teams  to Bullhorn
        </p>
    </novo-nav-content>
    <novo-nav-content>
      <novo-search icon="candidate" color="candidate" [alwaysOpen]="true">
        <entity-picker-results [matches]="searchData" ></entity-picker-results>
    </novo-search>
    </novo-nav-content>
  </novo-nav-outlet>
</div>
